var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.749,
    height: 15.081,
    viewBox: "0 0 20.749 15.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(-329.289 -21.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(329.289 21.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M250.447,85.36a.5.5,0,0,1-.5-.53.531.531,0,0,1,.53-.53H270.17a.53.53,0,1,1,0,1.06Z",
    transform: "translate(-249.952 -70.279)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M262.883,60.46a.53.53,0,1,1,0-1.06h15.3a.53.53,0,0,1,0,1.06Z",
    transform: "translate(-257.97 -52.407)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M250.447,35.66a.5.5,0,0,1-.5-.53.531.531,0,0,1,.53-.53H270.17a.53.53,0,1,1,0,1.06Z",
    transform: "translate(-249.952 -34.6)",
    fill: "#f0f0f0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.89b529e7c0b6a6d83aa2880b9111a0cd.svg";
export { ForwardRef as ReactComponent };